import { showFlash } from './flash_show';
window.up.compiler('.unpoly_wrapper', () => {
    if (!navigator.cookieEnabled) {
        const message = window.steadyI18n.cookiesDisabledWarning;
        showFlash('error', message);
    }
});
